/**
 * registry.ts — 登録された世界の画面の割り当て
 *
 * 世界を足したときは、その世界のフォルダの画面をここへ並べる。
 */

import { ComponentType } from "react";
import BaunheimAdminMenu from "../../../Baunheim/components/AdminMenu";
import BaunheimCharacterCreate from "../../../Baunheim/components/CharacterCreate";
import BaunheimCharacterReview from "../../../Baunheim/components/CharacterReview";
import BaunheimPlay from "../../../Baunheim/components/Play";
import BaunheimWorldIntro from "../../../Baunheim/components/WorldIntro";
import { AccountView } from "@/lib/types";

export interface WorldAdminProps {
  onBack: () => void;
}

export interface WorldCreateProps {
  region: string;
  account: AccountView;
  /** やり直す依頼の識別子。新しい依頼は null */
  requestId: string | null;
  onBack: () => void;
  /** 依頼の受け付け後。台帳が変わった場合は新しいアカウント情報を渡す */
  onDone: (account?: AccountView) => void;
}

export interface WorldReviewProps {
  region: string;
  /** 確かめるキャラのスラッグ */
  slug: string;
  account: AccountView;
  onBack: () => void;
  /** 決定か手直しの依頼の後。新しいアカウント情報を渡す */
  onDone: (account?: AccountView) => void;
}

export interface WorldPlayProps {
  region: string;
  /** 遊ぶキャラのスラッグ */
  slug: string;
  account: AccountView;
  /** キャラクター選択画面へ戻る */
  onExit: () => void;
  onLogout: () => void;
}

const ADMIN_SCREENS: Record<string, ComponentType<WorldAdminProps>> = {
  Baunheim: BaunheimAdminMenu,
};

const CREATE_SCREENS: Record<string, ComponentType<WorldCreateProps>> = {
  Baunheim: BaunheimCharacterCreate,
};

const REVIEW_SCREENS: Record<string, ComponentType<WorldReviewProps>> = {
  Baunheim: BaunheimCharacterReview,
};

const PLAY_SCREENS: Record<string, ComponentType<WorldPlayProps>> = {
  Baunheim: BaunheimPlay,
};

const WORLD_INTROS: Record<string, ComponentType> = {
  Baunheim: BaunheimWorldIntro,
};

/** その世界の紹介を返す。割り当てが無ければ null を返す */
export function worldIntro(world: string): ComponentType | null {
  return WORLD_INTROS[world] ?? null;
}

/** その世界のキャラクター確認画面を返す。割り当てが無ければ null を返す */
export function worldReviewScreen(world: string): ComponentType<WorldReviewProps> | null {
  return REVIEW_SCREENS[world] ?? null;
}

/** その世界のマスターデータ管理 UI を返す。割り当てが無ければ null を返す */
export function worldAdminScreen(world: string): ComponentType<WorldAdminProps> | null {
  return ADMIN_SCREENS[world] ?? null;
}

/** その世界のキャラクター作成画面を返す。割り当てが無ければ null を返す */
export function worldCreateScreen(world: string): ComponentType<WorldCreateProps> | null {
  return CREATE_SCREENS[world] ?? null;
}

/** その世界の、キャラを選んだ後の画面を返す。割り当てが無ければ null を返す */
export function worldPlayScreen(world: string): ComponentType<WorldPlayProps> | null {
  return PLAY_SCREENS[world] ?? null;
}
